<template>
  <v-app>
    <v-navigation-drawer app floating temporary right width="350" v-model="drawer">
      <v-list >
        <v-list-item class="pr-1">
          <v-spacer />
          <v-list-item-action class="ma-0">
            <v-btn class="primary--text" text large right icon @click="drawer=false">
              <v-icon>mdi-close</v-icon>
            </v-btn>

          </v-list-item-action>
        </v-list-item>
        <v-list-item to="/" @click="drawer=false">
          <v-list-item-avatar>
            <v-icon>mdi-home</v-icon>
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title class="primary--text">
              <h1>Home</h1>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-divider />
        <v-list-item>
          <v-list-item-avatar>
            <v-icon>mdi-video</v-icon>
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title class="primary--text">
              <h1>Videos</h1>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
      <v-list >
        <v-list-item three-line to="/videos/video1" @click="drawer=false">
          <v-list-item-avatar>
            <img :src="OppIcon" alt="Optima++ icon"/>
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title>Mechanism testing I.</v-list-item-title>
            <v-list-item-subtitle class="wrap-text">Testing a combustion reaction mechanism</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
        <v-list-item three-line to="/videos/video2" @click="drawer=false">
          <v-list-item-avatar>
            <img :src="OppIcon" alt="Optima++ icon"/>
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title>Mechanism testing II.</v-list-item-title>
            <v-list-item-subtitle class="wrap-text">Testing a combustion reaction mechanism using computer clusters</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
        <v-list-item three-line to="/videos/video3" @click="drawer=false">
          <v-list-item-avatar>
            <v-icon>mdi-xml</v-icon>
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title>ReSpecTh Kinetics Data format</v-list-item-title>
            <v-list-item-subtitle class="wrap-text">Encoding combustion experimental data</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
    <v-app-bar
        app
        color="#2E2E2E"
        dark
        height="60"
    >
      <div class="d-flex align-center">
        <v-img
            alt="CKinLab Logo"
            class="shrink mr-2"
            contain
          :src="CkinLab"
          transition="scale-transition"
          width="50"
        />
        <router-link to="/" class="logo-link">
        <h2 class="primary--text">
         Chemical Kinetics Laboratory | ELTE
        </h2>
        </router-link>
      </div>

      <v-spacer></v-spacer>
    <v-app-bar-nav-icon class="primary--text" @click.stop="drawer = !drawer">
      <v-icon v-text="drawer ? 'mdi-close' : 'mdi-menu'" />
    </v-app-bar-nav-icon>
    </v-app-bar>
    <v-main>
      <v-container fluid>
      <router-view />
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import CkinLab from '@/assets/CKinLab_K.png'
import OppIcon from '@/assets/opp_icon.png'

export default {
  name: 'App',
  data: () => ({
    CkinLab,
    OppIcon,
    drawer: false
  }),
};
</script>

<style>
.title h1 {
  line-height: 2.6rem;
}
.wrap-text {
  -webkit-line-clamp: unset !important;
}
.logo-link {
  text-decoration: none;
}
.code-block > code {
  background-color: #323232 !important;
}
.optimapp > .hljs-block > .hljs-keyword {
  color: #ffa07a;
}

.optimapp > .hljs-number {
  color: aqua;
}

.optimapp > .hljs-comment {
  color: lightgrey;
}

.optimapp > .hljs-literal {
  font-style: italic;
}

code.shortcut {
  background-color: #424242 !important;
  color: goldenrod !important;
}
.markdown  img {
  display: block;
  margin-left: auto;
  margin-right: auto;
}
::-webkit-scrollbar {
  width: 15px;
}

::-webkit-scrollbar-track {
  background: #202020;
  border-left: 1px solid #2c2c2c;
}

::-webkit-scrollbar-thumb {
  background: #3e3e3e;
  border: solid 3px #202020;
  border-radius: 7px;
}

::-webkit-scrollbar-thumb:hover {
  background: white;
}
</style>